import styled from 'styled-components';
import { devices } from 'shared/styles/components';

export const ProductsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ProductsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
`;

export const ProductCardWrapper = styled.div`
  position: relative;
  display: flex;
  height: 100%;
`;

export const ProductCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 48px;
  width: 100%;
  height: 100%;
  margin-bottom: 0px;
  padding: 32px;
  max-width: none;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.bgSecondary};
  cursor: pointer;
  text-decoration: none !important;
  user-select: none;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  transition: box-shadow 200ms ease;

  &:hover {
    box-shadow: 0 8px 15px 0 rgb(128 128 128 / 15%);
    text-decoration: none !important;
  }

  &:hover * {
    text-decoration: none !important;
  }

  h2,
  p,
  span,
  * {
    text-decoration: none !important;
  }

  @media ${devices.tabletMax} {
    flex-direction: column;
    gap: 16px;
    padding: 24px;
    align-items: flex-start;
  }

  @media ${devices.mobileMax} {
    padding: 20px;
  }
`;

export const ProductCardHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-shrink: 0;
  width: 280px;

  h2 {
    margin: 0;
    color: ${({ theme }) => theme.colors.textEmphasis};
    font-size: 22px;
    font-family: ${({ theme }) => theme.fontFamily.headline};
    font-weight: 500;
    text-align: left;
  }

  .tagline {
    display: flex;
    align-items: center;
    white-space: nowrap;
    color: ${({ theme }) => theme.colors.textTertiary};
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;

    @media ${devices.mobileMax} {
      font-size: 12px;
    }
  }

  @media ${devices.tabletMax} {
    width: 100%;
  }

  @media ${devices.mobileMax} {
    h2 {
      font-size: 20px;
    }
  }
`;

export const ProductCardBody = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 8px;

  .meta {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
  }

  .status,
  .release {
    display: flex;
    align-items: center;
    white-space: nowrap;
    color: ${({ theme }) => theme.colors.textSecondary};
    font-size: 13px;

    @media ${devices.mobileMax} {
      font-size: 11px;
    }

    .dot {
      margin-top: 1px;
      border-radius: 50%;
      width: 8px;
      height: 8px;
      margin-right: 6px;
      flex-shrink: 0;

      &.available {
        background-color: ${({ theme }) => theme.colors.success};
      }

      &.in-development {
        background-color: ${({ theme }) => theme.colors.warning};
      }

      &.release {
        background-color: ${({ theme }) => theme.colors.textTertiary};
      }
    }
  }

  p {
    margin: 0;
    color: ${({ theme }) => theme.colors.textPrimary};
    font-size: 16px;
    line-height: 24px;
    text-align: left;

    @media ${devices.mobileMax} {
      font-size: 14px;
      line-height: 20px;
    }
  }
`;

export const ProductCardFooter = styled.div`
  display: none;
`;
